// Mock data for Reverse Mortgage Landing Page

export const testimonials = [
  {
    id: 1,
    name: "Robert & Linda Martinez",
    age: 68,
    location: "Denver, CO",
    text: "Working with this team was the best financial decision we made for our retirement. The reverse mortgage allowed us to stay in our home and enjoy our golden years without financial stress.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1758691031818-02a1e7d90aff"
  },
  {
    id: 2,
    name: "Patricia Johnson",
    age: 71,
    location: "Colorado Springs, CO",
    text: "As a widow, I was worried about making ends meet. The reverse mortgage gave me financial freedom while keeping my home. The process was straightforward and professionally handled.",
    rating: 5,
    image: "https://images.pexels.com/photos/3831612/pexels-photo-3831612.jpeg"
  },
  {
    id: 3,
    name: "James & Carol Stevens",
    age: 65,
    location: "Boulder, CO",
    text: "We were skeptical at first, but the detailed explanations and professional guidance made us feel confident. Now we can travel and enjoy retirement without touching our savings.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1758686253692-2d6921de12dd"
  }
];

export const faqs = [
  {
    id: 1,
    question: "What is a reverse mortgage?",
    answer: "A reverse mortgage is a loan that allows homeowners age 62 or older to convert part of their home equity into cash without having to sell their home or make monthly mortgage payments. The loan is repaid when the borrower no longer lives in the home."
  },
  {
    id: 2,
    question: "Who qualifies for a reverse mortgage in Colorado?",
    answer: "To qualify, you must be at least 62 years old, own your home outright or have a low mortgage balance, live in the home as your primary residence, and maintain the property. The home must meet FHA property standards and you must complete HUD-approved counseling."
  },
  {
    id: 3,
    question: "How much money can I receive?",
    answer: "The amount depends on several factors: your age, current interest rates, the appraised value of your home, and FHA lending limits. Generally, the older you are and the more valuable your home, the more you can borrow. Our calculator can give you an estimate."
  },
  {
    id: 4,
    question: "Do I still own my home?",
    answer: "Yes! You retain ownership of your home. Your name stays on the title, and you can leave the home to your heirs. However, you must continue to pay property taxes, insurance, HOA fees, and maintain the property."
  },
  {
    id: 5,
    question: "When does the loan need to be repaid?",
    answer: "The loan becomes due when the last borrower passes away, sells the home, or permanently moves out. Your heirs can choose to repay the loan and keep the home, or sell the home to pay off the loan. Any remaining equity belongs to your heirs."
  },
  {
    id: 6,
    question: "What are the costs involved?",
    answer: "Costs include origination fees, closing costs, mortgage insurance premiums, and servicing fees. Many of these costs can be financed into the loan. I'll provide a detailed breakdown during our consultation so you understand all costs upfront."
  },
  {
    id: 7,
    question: "Can I lose my home with a reverse mortgage?",
    answer: "As long as you meet loan obligations—paying property taxes, homeowners insurance, maintaining the home, and living there as your primary residence—you cannot lose your home. The loan balance never exceeds the home's value due to FHA insurance."
  },
  {
    id: 8,
    question: "How is this different from a home equity loan?",
    answer: "Unlike a home equity loan or HELOC, a reverse mortgage doesn't require monthly payments. Instead, the loan balance grows over time with interest. You receive money from the lender rather than making payments to them."
  },
  {
    id: 9,
    question: "How do I talk to my adult children about reverse mortgages?",
    answer: "Adult children often have concerns about reverse mortgages because they may worry about their inheritance or have heard outdated information. Start by sharing this guide and inviting them to a consultation with me. I'm happy to answer their questions about how the loan works, protections for you and them, and how it fits into your overall financial plan. Many families find that once they understand the tax benefits, wealth preservation strategies, and non-recourse protections, they become supportive. Remember: this is YOUR home and YOUR decision. A reverse mortgage can actually help preserve MORE wealth for your heirs by protecting investment accounts and optimizing your tax situation."
  }
];

export const benefits = [
  {
    id: 1,
    icon: "Home",
    title: "Stay in Your Home",
    description: "Continue living in the home you love while accessing your equity. No need to downsize or relocate."
  },
  {
    id: 2,
    icon: "DollarSign",
    title: "Strategic Liquidity Management",
    description: "Coordinate housing equity draws with traditional RMDs and investment withdrawals to optimize cash flow across your retirement income sources."
  },
  {
    id: 3,
    icon: "Shield",
    title: "Tax Bracket Protection",
    description: "Loan proceeds don't count as taxable income—access funds without triggering higher tax brackets or affecting Medicare IRMAA premiums."
  },
  {
    id: 4,
    icon: "TrendingUp",
    title: "Portfolio Protection Strategy",
    description: "Set up a standby line of credit to draw from during market downturns, protecting your investments from forced liquidations in down markets."
  },
  {
    id: 5,
    icon: "Users",
    title: "Generational Wealth Preservation",
    description: "Non-recourse protection ensures you or your heirs never owe more than the home's value. Remaining equity passes to your estate."
  },
  {
    id: 6,
    icon: "PiggyBank",
    title: "Asset Coordination",
    description: "Coordinate with your tax strategy to help delay Social Security or fund Roth conversions."
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Schedule Your Free Consultation",
    description: "Book your free 30-minute phone call to discuss your goals, review your home equity, and determine if a reverse mortgage is right for you.",
    icon: "MessageSquare",
    link: "/schedule"
  },
  {
    id: 2,
    title: "HUD Counseling",
    description: "Complete required counseling with a HUD-approved counselor to ensure you understand the product. This must be completed before application.",
    icon: "GraduationCap"
  },
  {
    id: 3,
    title: "Application & Appraisal",
    description: "Submit your application and we'll order a home appraisal to determine your property's value.",
    icon: "FileText"
  },
  {
    id: 4,
    title: "Underwriting & Approval",
    description: "Our team processes your application, reviews documentation, and obtains final loan approval.",
    icon: "CheckCircle"
  },
  {
    id: 5,
    title: "Closing",
    description: "Sign your loan documents and receive your funds according to your selected payment option.",
    icon: "Award"
  }
];

export const eligibilityRequirements = [
  {
    id: 1,
    requirement: "Be at least 62 years old (all homeowners on title)",
    met: true
  },
  {
    id: 2,
    requirement: "Own your home outright or have substantial equity",
    met: true
  },
  {
    id: 3,
    requirement: "Live in the home as your primary residence",
    met: true
  },
  {
    id: 4,
    requirement: "Property must be a single-family home, 2-4 unit property, FHA-approved condo, or manufactured home",
    met: true
  },
  {
    id: 5,
    requirement: "Home must meet FHA property standards",
    met: true
  },
  {
    id: 6,
    requirement: "Be current on federal debt obligations",
    met: true
  },
  {
    id: 7,
    requirement: "Complete HUD-approved reverse mortgage counseling",
    met: true
  },
  {
    id: 8,
    requirement: "Have the financial capacity to pay property taxes, insurance, and maintenance",
    met: true
  }
];
